module.exports = __webpack_public_path__ + "static/media/ellipsis-vertical.9f3d1d2b.svg";